var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoffeeCup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.188 9.375h-1.563l-2.413-7.238A3.123 3.123 0 0035.248 0H8.49C7.145 0 5.964.86 5.538 2.137L3.125 9.375H1.562C.7 9.375 0 10.075 0 10.938v3.124c0 .864.7 1.563 1.563 1.563H3.5l2.52 31.499A3.126 3.126 0 009.135 50h25.48a3.126 3.126 0 003.115-2.876l2.52-31.499h1.938c.863 0 1.562-.7 1.562-1.563v-3.124c0-.864-.7-1.563-1.563-1.563zM9.627 4.687h24.493l2.083 6.25H7.544l2.085-6.25zm.95 40.626l-.75-9.376h24.094l-.75 9.376H10.577zm24.47-23.438H8.702l-.5-6.25h27.345l-.5 6.25z",
    fill: "#91C300"
  })));
}

export default SvgCoffeeCup;